// Bewegung in den Abschnitten unter dem Kopfbereich (aus ~/Projects/davidmedia-header-test/index.html):
// Werkzeug-Filter, Studio-Flow-Panel im Wechsel, Preis-Zähler, Installer-Ladebalken, Einblenden beim
// Scrollen, Zeitlinien und Glas-Rand mit Cursor-Licht. Gibt eine Aufräum-Funktion zurück.

export function starteAbschnitte({ wurzel, T, panels, preise }) {
  const $ = id => wurzel.querySelector('#' + id);
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let aus = false;
  const timer = new Set();
  const spaeter = (fn, ms) => { const id = setTimeout(() => { timer.delete(id); if (!aus) fn(); }, ms); timer.add(id); return id; };
  const aufraeumen = [];
  const hoer = (ziel, typ, fn, opt) => { if (!ziel) return; ziel.addEventListener(typ, fn, opt); aufraeumen.push(() => ziel.removeEventListener(typ, fn, opt)); };

  // ---------- Werkzeug-Filter und Suche (die Suche gibt es nur auf der Werkzeuge-Seite) ----------
  let filter = 'alle', suche = '';
  const filtern = () => {
    let sichtbar = 0;
    wurzel.querySelectorAll('#raster .karte').forEach(k => {
      const weg = (filter !== 'alle' && k.dataset.kat !== filter) || (suche && !(k.dataset.suche || '').includes(suche));
      k.classList.toggle('weg', weg);
      if (!weg) sichtbar++;
    });
    if ($('leer')) $('leer').hidden = sichtbar > 0;
  };
  hoer($('chips'), 'click', e => {
    const f = e.target.dataset.f; if (!f) return;
    filter = f;
    wurzel.querySelectorAll('.chip').forEach(c => c.classList.toggle('an', c === e.target));
    filtern();
  });
  if ($('suche')) hoer($('suche'), 'input', e => { suche = e.target.value.trim().toLowerCase(); filtern(); });

  // ---------- Studio-Flow-Panel: echte Ansichten im Wechsel ----------
  const panel = $('panel'), tabs = $('tabs');
  const bilder = !panel ? [] : panels.map(([, f], i) => {
    const im = new Image(); im.src = f; im.alt = ''; if (i) im.className = 'weg'; panel.appendChild(im); return im;
  });
  // Titelleiste exakt in der Farbe des Panels einfärben (die Screenshots tragen noch den alten Namen)
  if (bilder[0]) bilder[0].addEventListener('load', () => {
    try {
      const c = document.createElement('canvas'); c.width = 8; c.height = 8;
      const x = c.getContext('2d'); x.drawImage(bilder[0], 40, 8, 8, 8, 0, 0, 8, 8);
      const [r, g, b] = x.getImageData(2, 2, 1, 1).data;
      $('ptitel').style.background = `rgb(${r},${g},${b})`;
    } catch (e) {}
  });
  if (tabs) tabs.innerHTML = panels.map(([n], i) => `<button class="tab${i ? '' : ' an'}" data-i="${i}">${n}</button>`).join('');
  let panelI = 0, panelTimer = null;
  function zeigePanel(i) {
    if (!tabs) return;
    panelI = i;
    bilder.forEach((b, k) => b.classList.toggle('weg', k !== i));
    tabs.querySelectorAll('.tab').forEach((t, k) => { t.classList.remove('an'); if (k === i) { void t.offsetWidth; t.classList.add('an'); } });
    if (panelTimer) { clearTimeout(panelTimer); timer.delete(panelTimer); }
    if (!ruhig) panelTimer = spaeter(() => zeigePanel((panelI + 1) % panels.length), 3400);
  }
  hoer(tabs, 'click', e => { if (e.target.dataset.i) zeigePanel(+e.target.dataset.i); });

  // ---------- Preis ----------
  let preisArt = 'jahr';
  const betrag = $('betrag');
  function zeigePreis(zaehlen) {
    if (!betrag) return;
    const p = preise[preisArt];
    $('einheit').textContent = p.einheit;
    $('unter').textContent = p.unter;
    if (!zaehlen || ruhig) { betrag.textContent = p.format(p.betrag); return; }
    const t0 = performance.now();
    (function schritt(now) {
      if (aus) return;
      const k = clamp((now - t0) / 1100), e = 1 - Math.pow(1 - k, 4);
      betrag.textContent = p.format(p.betrag * e);
      if (k < 1) requestAnimationFrame(schritt);
    })(t0);
  }
  hoer($('umschalter'), 'click', e => {
    if (!e.target.dataset.p) return;
    preisArt = e.target.dataset.p;
    wurzel.querySelectorAll('#umschalter button').forEach(b => b.classList.toggle('an', b === e.target));
    zeigePreis(true);
  });

  // ---------- Installer-Fenster: Ladebalken laufen durch ----------
  function installerLaeuft() {
    const offen = [...wurzel.querySelectorAll('#instfenster .status[data-fertig]')];
    offen.forEach((s, i) => spaeter(() => {
      s.className = 'status laedt'; s.querySelector('em').textContent = i ? T.laedt : T.aktualisiert;
      requestAnimationFrame(() => { s.querySelector('.balken').style.width = '100%'; });
      spaeter(() => {
        const bk = s.querySelector('.balken'); bk.style.transition = 'none'; bk.style.width = '0';
        s.className = 'status ok';
        s.querySelector('em').textContent = s.dataset.fertig;
        // auch die kleine Zeile darunter („Update verfügbar“) passend zum fertigen Zustand
        if (s.dataset.kleinFertig) s.closest('.frow').querySelector('small').textContent = s.dataset.kleinFertig;
        $('instinfo').textContent = i === offen.length - 1 ? T.allesAktuell : T.eineAktion;
      }, 2300);
    }, 500 + i * 1300));
  }

  // ---------- Einblenden beim Scrollen ----------
  const einmal = new Map([['all-in-one', () => { zeigePanel(0); zeigePreis(true); }], ['instfenster', installerLaeuft]]);
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    const f = einmal.get(e.target.id); if (f) { f(); einmal.delete(e.target.id); }
    io.unobserve(e.target);
  }), { threshold: .18 });
  wurzel.querySelectorAll('.reveal, .reveal-text, #all-in-one, #instfenster').forEach(el => io.observe(el));
  aufraeumen.push(() => io.disconnect());
  // Gestaffeltes Einblenden nur beim ersten Mal: danach reagiert Hover ohne Verzögerung
  hoer(wurzel, 'transitionend', e => {
    if (e.propertyName === 'opacity' && e.target.classList && e.target.classList.contains('reveal')) e.target.style.transitionDelay = '0s';
  });

  // ---------- Zeitlinien: die Raute läuft beim Scrollen über die Linie ----------
  const linien = [...wurzel.querySelectorAll('.zeitlinie')];
  let linienRaf = 0;
  function linienSetzen() {
    linienRaf = 0;
    for (const l of linien) {
      const r = l.getBoundingClientRect();
      if (r.top > innerHeight || r.bottom < -400) continue;
      const z = clamp((innerHeight - r.top) / (innerHeight * .75));
      l.style.setProperty('--z', z.toFixed(3)); l.style.setProperty('--zx', (z * r.width).toFixed(1) + 'px');
    }
  }
  const linienPlanen = () => { if (!linienRaf) linienRaf = requestAnimationFrame(linienSetzen); };
  hoer(window, 'scroll', linienPlanen, { passive: true });
  hoer(window, 'resize', linienPlanen);
  linienSetzen();

  // ---------- Glas-Rand + Cursor-Licht (aus effekte.js der Demo) ----------
  wurzel.querySelectorAll('.karte, .preiskarte').forEach(el => {
    if (el.dataset.fx) return;
    el.dataset.fx = '1'; el.classList.add('fx');
    el.insertAdjacentHTML('beforeend', '<span class="fx-licht"></span><span class="fx-rand"></span>');
  });
  wurzel.querySelectorAll('.btn.primaer').forEach(b => b.style.setProperty('--sv', (1 + Math.random() * 4).toFixed(2) + 's'));
  hoer(wurzel, 'pointermove', e => {
    const el = e.target.closest && e.target.closest('.fx');
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
    el.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
  }, { passive: true });

  return function stoppeAbschnitte() {
    aus = true;
    cancelAnimationFrame(linienRaf);
    timer.forEach(id => clearTimeout(id)); timer.clear();
    aufraeumen.forEach(fn => { try { fn(); } catch (e) {} });
  };
}
